exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#registration-customer-sign-up{margin-top:-40px;width:50%;max-width:800px}#registration-customer-sign-up .customer-sign-up-left-col{border-right:1px solid rgba(0,0,0,.1);padding-right:20px}#registration-customer-sign-up .customer-sign-up-right-col{padding-left:20px}.sign-up-confirmation{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}", ""]);

// exports
